import {
    USER_CHOOSE_CURRENT_FRUI_PFBZ,
} from './constants';
  
export function chooseCurrentFrui_pfbz(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_PFBZ,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_PFBZ:
        return {
          ...state,
          currentFrui_pfbz:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_pfbz.js